import React, {  } from "react"
import styled, {  } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { P } from "src/components/DOM"
import {  } from "src/components/utils"
import { mainTheme } from "src/GlobalStyle"


// breakline
const BreakLineRoot = styled.div`
    position: relative;
    padding: ${props => `${props.paddingTop}px 0 ${props.paddingBottom}px`};
    width: ${props => props.width ? `${props.width}px` : "100%"};
    ${breakpoint("mobile", "desktop")`
        width: 100%;
    `}
    margin: auto;
`
const Line = styled.div`
    width: 100%;
    height: 1px;
    background: ${props => props.theme.primary};
    position: relative;

    ::before, ::after {
        content: "";
        position: absolute;
        height: 6px;
        width: 6px;
        transform: translateY(-50%);
        background: ${props => props.theme.primary};
        border-radius: 100%;
    }
    ::after {
        right: 0;
    }
`
export const BreakLine = ({ width, paddingTop=0, paddingBottom=0 }) => {

    return <BreakLineRoot width={width} paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Line />
    </BreakLineRoot>
}
export const GrayBreakLine = ({ width, paddingTop=0, paddingBottom=0, paddingLeft=0, paddingRight=0 }) => {
    const Line = styled.div`
        width: 100%;
        height: 1px;
        background: #dce3e7;
        position: relative;
    `

    return <BreakLineRoot width={width} paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Line />
    </BreakLineRoot>
}


export const DeargenLogo = ({ color=mainTheme.primary, width=90, onClick }) => {
    return <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={width} height="27" viewBox="0 0 116 27">
        <path fill={color} fillRule="evenodd" d="M77.213 22.001c1.332 0 2.414 1.119 2.414 2.5 0 1.38-1.082 2.499-2.414 2.499-1.161 0-2.13-.85-2.36-1.981h-4.008a1.049 1.049 0 0 1-.927.573c-.581 0-1.053-.489-1.053-1.091 0-.603.472-1.09 1.053-1.09.4 0 .75.23.927.571l4.007.001c.23-1.132 1.2-1.982 2.361-1.982zm26.823-17.454l8.7 11.96h.043V5.001H116v17.452h-2.322l-8.7-11.96h-.043v11.62h-3.221V4.547h2.322zM4.601 5.17c4.778 0 7.975 3.7 7.975 8.578 0 4.812-3.286 8.534-7.996 8.534H0V5.171h4.601zm20.289 0v2.905h-5.325v3.768h5.127v2.905h-5.127v4.63h5.325v2.904h-8.546V5.171h8.546zm11.895-.454l6.269 17.567h-3.441l-1.271-3.609h-5.74l-1.36 3.609h-3.396l6.442-17.567h2.497zm13.804.454c3.265 0 5.522 1.498 5.522 5.152 0 2.179-1.161 4.357-3.375 4.743l4.668 7.217h-3.9l-4.01-6.899h-.045v6.9h-3.221V5.17h4.361zm46.787-.17v2.905h-5.324v3.767h5.127v2.906h-5.127v4.63h5.324v2.904h-8.545V5.001h8.545zM81.228 16.955c1.091 0 1.975.916 1.975 2.046s-.884 2.044-1.975 2.044c-.918 0-1.689-.648-1.91-1.526H66.424c-.2.534-.702.913-1.29.913-.762 0-1.38-.64-1.38-1.431 0-.79.618-1.431 1.38-1.431.588 0 1.09.379 1.29.913h12.894c.221-.879.992-1.528 1.91-1.528zM3.746 8.075h-.525V19.38h.525c3.967 0 5.501-2.27 5.501-5.651 0-3.722-1.84-5.653-5.501-5.653zm31.638 1.658h-.044l-1.819 6.219h3.923l-2.06-6.22zm46.904 1.95c.97 0 1.755.814 1.755 1.818 0 1.003-.786 1.817-1.755 1.817-.796 0-1.467-.548-1.682-1.3h-15.44c-.216.752-.888 1.3-1.683 1.3-.97 0-1.755-.814-1.755-1.817 0-1.004.785-1.818 1.755-1.818.795 0 1.467.548 1.682 1.3h15.44c.216-.752.887-1.3 1.683-1.3zm-32.4-3.788h-.44v5.152h.418c1.775 0 3.024-.545 3.024-2.634 0-2.11-1.292-2.518-3.002-2.518zm14.654-1.94c.918 0 1.69.649 1.911 1.527h12.894c.2-.534.702-.914 1.288-.914.764 0 1.383.642 1.383 1.432 0 .79-.619 1.431-1.383 1.431a1.384 1.384 0 0 1-1.288-.913H66.453c-.221.879-.993 1.527-1.91 1.527-1.091 0-1.976-.915-1.976-2.045s.885-2.045 1.975-2.045zM68.558 0c1.162 0 2.132.85 2.362 1.982h4.007c.178-.342.526-.573.927-.573.58 0 1.053.488 1.053 1.091 0 .602-.472 1.09-1.053 1.09-.4 0-.75-.23-.927-.572H70.92c-.23 1.131-1.2 1.981-2.362 1.981-1.332 0-2.414-1.119-2.414-2.499 0-1.381 1.082-2.5 2.414-2.5z"/>
    </svg>
}

// capsule logo used in mobile
const CapsuleTextRoot = styled.div`
    position: relative;
    width: 100%;
    ${props => props.customCss}
`
const CapsuleP = styled(P)`
    padding-left: 40px;
    font-weight: 600;
    color: ${props => props.textColor};
    // left part of capsule
    ::before {
        z-index: 1;
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 20px;
        height: 13px;
        border-radius: 40px;
        background: ${props => props.leftColor};
        transform: translateY(-50%);
    }
    // right part of capsule
    ::after {
        content: "";
        position: absolute;
        left: 10px;
        top: 50%;
        width: 20px;
        height: 13px;
        border-radius: 40px;
        background: ${props => props.rightColor};
        transform: translateY(-50%);

    }
`
export const CapsuleText = ({
    textColor=mainTheme.primary,
    leftColor=mainTheme.primary,
    rightColor=mainTheme.secondary,
    customCss,
    children 
}) => {

    return <CapsuleTextRoot customCss={customCss}>
        <CapsuleP textColor={textColor} leftColor={leftColor} rightColor={rightColor}>
            {children}
        </CapsuleP>
    </CapsuleTextRoot>
}